import {useState} from "react";

export default function SystemKeyboardKeyItem({item, onKeyButtonPressed, isKeyButtonDisabled, isKeyNonNumeric}) {
    // Used in MultiplicationGameKeyboard to display one single
    // key for the specific multiplication game

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    return (
        <div className={`select-none ${renderKeyItemStyle()} h-[40px] min-h-[48px] flex justify-center items-center rounded-[8px]`}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onClick={() => {onKeyButtonPressed(item)}} >
            <span className={`font-medium text-greyLight1`}>
                {item}
            </span>
        </div>
    );

    // METHODS
    // ---- UI : Render Key item background color
    function renderKeyItemStyle() {
        return isKeyButtonDisabled(item)
            ? 'bg-greyLight5 cursor-not-allowed'
            : isHovered
                ? isKeyNonNumeric
                    ? 'bg-purpleLight2 cursor-pointer'
                    : 'bg-bearBodyWhiteLight1 cursor-pointer'
                : isKeyNonNumeric
                    ? 'bg-purpleLight1 cursor-pointer'
                    : 'bg-bearBodyWhiteColor cursor-pointer'
    }
}
